(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const currentCodes = container =>
    (container.dataset.codes || '').split(',').map(c => c.trim()).filter(Boolean);

  const setCodes = codes =>
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(r => r.json());

  async function refresh() {
    if (window.cartRewardsUI) {
      await window.cartRewardsUI.sync();
      await window.cartRewardsUI.refresh();
    } else {
      location.reload();
    }
  }

  function showError(container, message) {
    const el = container.querySelector('[data-discount-error]');
    el.textContent = message;
    el.hidden = false;
  }

  async function apply(container) {
    const input = container.querySelector('[name="discount_code"]');
    const button = container.querySelector('[data-discount-apply]');
    const code = input.value.trim();
    if (!code) return;

    const codes = currentCodes(container);
    if (codes.some(c => c.toLowerCase() === code.toLowerCase())) {
      showError(container, 'Dieser Code ist bereits eingelöst.');
      return;
    }

    button.disabled = true;
    try {
      const cart = await setCodes([...codes, code]);
      const result = (cart.discount_codes || []).find(d => d.code.toLowerCase() === code.toLowerCase());

      if (!result || !result.applicable) {
        await setCodes(codes);
        showError(container, 'Dieser Rabattcode ist ungültig oder die Bedingungen sind nicht erfüllt.');
        return;
      }
      await refresh();
    } catch (e) {
      showError(container, 'Etwas ist schiefgelaufen. Bitte versuche es erneut.');
    } finally {
      button.disabled = false;
    }
  }

  document.addEventListener('click', async event => {
    const applyButton = event.target.closest('[data-discount-apply]');
    if (applyButton) {
      apply(applyButton.closest('[data-cart-discount]'));
      return;
    }

    const removeButton = event.target.closest('[data-discount-remove]');
    if (removeButton) {
      const container = removeButton.closest('[data-cart-discount]');
      const code = removeButton.dataset.discountRemove.toLowerCase();
      removeButton.disabled = true;
      await setCodes(currentCodes(container).filter(c => c.toLowerCase() !== code));
      await refresh();
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-cart-discount] [name="discount_code"]')) {
      event.preventDefault();
      apply(event.target.closest('[data-cart-discount]'));
    }
  });
})();